/**
 * Turkish. The reference text, because this is the language the product was specified in and
 * the one the people using it speak.
 *
 * <p>Keys are grouped by where they are read, not by what kind of word they are. A translator
 * fixing a screen wants everything that screen says in one place.</p>
 */
export const tr: Record<string, string> = {
  // ---------------------------------------------------------------- shell
  'app.name': "Norva",
  'app.definitions': 'Tanım ekranları',
  'app.signOut': 'Çıkış',
  'app.updateReady': 'Yeni sürüm hazır.',
  'app.updateNow': 'Şimdi yenile',
  'app.language': 'Dil',

  'app.templates': 'Şablonlar',
  'nav.templates': 'Denetim Formu Şablonları',

  'templates.title': 'Denetim Formu Şablonları',
  'templates.subtitle': '{count} şablon · üç tanımın birleştiği yer',
  'templates.code': 'Kod',
  'templates.codeHint': 'Sürümler arasında değişmez. Denetim hangi forma göre yapıldığını bununla söyler.',
  'templates.name': 'Ziyaret Adı',
  'templates.visitType': 'Ziyaret Başlığı',
  'templates.notice': 'Haberli / Habersiz',
  'templates.scoring': 'Puanlama Tipi',
  'templates.scored': 'Puanlı',
  'templates.unscored': 'Puansız',
  'templates.status': 'Durum',
  'templates.period': 'Geçerlilik',
  'templates.from': 'Başlangıç Tarihi',
  'templates.to': 'Bitiş Tarihi',
  'templates.questions': 'Soru',
  'templates.open': 'Aç',
  'templates.empty': 'Henüz şablon yok.',
  'templates.notFound': 'Şablon bulunamadı.',
  'templates.backToList': 'Listeye dön',
  'visitTypes.templateChip': 'Şablon',
  'templates.publishTitle': '{name} v{version} yayınlansın mı?',
  'templates.publishBody': 'Yayınlanan sürümün soruları, ağırlıkları ve puanları bir daha değişmez; değişiklik için yeni sürüm açılır. Bu sürümle başlayan denetimler bu sürümle puanlanır.',
  'templates.outOfPeriod': 'tarih dışı',
  'templates.superseded': 'v{version} ile değişti',
  'templates.supersededHint': 'Bu sürümle başlamış denetimler bu sürümle biter; yeni denetim ve plan en yeni sürümle açılır.',
  'templates.summary': '{questions} soru · {categories} kategori',
  'templates.weight': 'Ağırlık',
  'templates.share': 'Pay',
  'templates.moveUp': 'Yukarı',
  'templates.moveDown': 'Aşağı',
  'templates.removeQuestion': 'Formdan çıkar',
  'templates.removeCategory': 'Kategoriyi kaldır',
  'templates.approvalChain': 'Aksiyon onay zinciri',
  'templates.approvalChainHint': 'Bu formdan açılan onaylı aksiyonlar bu koltuklardan sırayla geçer. Boş bırakılırsa aksiyon, işi yapanın sözüyle kapanır. Adım koltuk türünü belirtir: bir bölgeyi kapsayan koltuk seçerseniz, aksiyon denetlenen mağazanın kendi bölgesindeki aynı türden koltuğa gider — yani tek form bütün bölgelerde doğru çalışır. Her yeri kapsayan koltuklar (direktör, kalite müdürü gibi) olduğu gibi kalır.',
  'templates.addApprover': 'Onaycı ekle…',
  'templates.chainOrder': 'Sıra',
  'templates.chainOrderHint': 'Sorumlu cevapladıktan sonra sırayla bu koltuklara gider. Son onaycı kapatır.',
  'templates.removeApprover': 'Onaycıyı çıkar',
  'templates.noChain': 'Zincir yok: bu formun aksiyonları tek adımda, işi yapanın sözüyle kapanır.',
  'error.form.approval-step.position.required': 'Onay adımının bir koltuğu olmalı.',
  'templates.removeCategoryTitle': '{name} kategorisi kaldırılsın mı?',
  'templates.removeCategoryWarning': 'İçindeki {count} soru da gider. Soruları kitaplıktan tekrar ekleyebilirsin, ama ağırlıkları geri gelmez.',
  'templates.noQuestions': 'Henüz soru eklenmedi. Sağdaki panelden seç.',
  'templates.addQuestions': 'Soru ekleme',
  'templates.alreadyOnForm': 'formda',
  'templates.picked': '{count} soru seçildi',
  'templates.pickSome': 'Soru seç',
  'templates.addSelected': 'Seçilenleri ekle',
  'templates.publish': 'Yayınla',
  'templates.archive': 'Arşivle',
  'templates.newVersion': 'Yeni sürüm oluştur (v{version})',
  'templates.goToNewest': 'Bu şablonun v{version} sürümü var — oraya git',
  'templates.flatten': 'Kategorileri soru ağırlıklarına göre eşitle',
  'templates.points': 'Puan',
  'templates.totalPoints': 'toplam {total} / {target} puan',
  'templates.pointsHint':
    'Her soru kendi puanını taşır; kategori, sorularının toplamı kadar eder ve elle değiştirilemez. Toplam hedefi tutmadan şablon yayımlanamaz. Uygulanamaz işaretlenen soru, kütüphanedeki ayarı ne olursa olsun formdan düşer; kalan puanlar hedefe ölçeklenir.',
  'templates.scoringModel': 'Puanlama',
  'templates.scoringModelHint':
    'Ağırlık: sayılar görelidir. Puan: her soru kendi puanını taşır, toplam hedefe eşit olmalı. Yayımlandıktan sonra değişmez.',
  'templates.flattenHint': 'Eşitleme, her kategorinin ağırlığını içindeki soruların toplamına çeker: soru sayısı çok olan kategori daha çok pay alır. İkisi aynı cevaplar için farklı puan verir.',
  'templates.cannotPublish': 'Yayınlanamaz:',
  'templates.readyToPublish': 'Yayınlanmaya hazır.',
  'templates.lockedNotice': 'Bu şablon yayında. Soruları ve ağırlıkları değişmez — geçmiş denetimler v{version}\'e göre puanlandı.',
  'templates.totalWeight': 'toplam ağırlık {weight}',

  'formStatus.Draft': 'Taslak',
  'formStatus.Published': 'Yayında',
  'formStatus.Archived': 'Arşiv',
  'notice.Announced': 'Haberli',
  'notice.Unannounced': 'Habersiz',

  'error.form.period.backwards': 'Bitiş tarihi başlangıçtan önce — kimsenin kullanamayacağı bir şablon olur.',
  'error.form.not-draft': 'Yayınlanmış bir şablon değiştirilemez. Değişiklik için yeni sürüm oluşturun.',
  'error.location.out-of-reach': '{code} sizin sorumluluk alanınızda değil. Bir hata olduğunu düşünüyorsanız yöneticinize başvurun.',
  'error.form.not-latest': 'Bu şablonun v{version} sürümü zaten var. Yeni sürüm en sonuncusundan oluşturulur.',
  'error.form.weight.positive': 'Ağırlık sıfırdan büyük olmalı.',
  'error.form.points-target.positive': 'Toplam puan hedefi sıfırdan büyük olmalı.',
  'error.form.category.weight-derived':
    'Puan modelinde kategori, sorularının toplamı kadar eder. Soru puanını değiştirin.',

  'nav.visitTypes': 'Ziyaret Tipleri',
  'nav.categories': 'Kategoriler',
  'nav.questions': 'Sorular',

  // ---------------------------------------------------------------- common
  'common.add': "Ekle",
  'common.save': 'Kaydet',
  'common.cancel': "İptal",
  'common.dismiss': "Vazgeç",
  'common.edit': 'Düzenle',
  'common.delete': 'Sil',
  'common.close': 'Kapat',
  'common.previous': 'Önceki',
  'common.retry': 'Tekrar dene',
  'common.next': 'Sonraki',
  'common.loading': 'Yükleniyor…',
  'common.optional': 'İsteğe bağlı',
  'common.none': '—',
  'common.retire': 'Emekliye ayır',
  'common.reinstate': 'Geri al',

  // ---------------------------------------------------------------- sign in
  'login.title': 'Oturum aç',
  'login.email': 'E-posta',
  'login.password': 'Parola',
  'login.submit': 'Giriş',
  'login.working': 'Kontrol ediliyor…',
  'login.failed': 'E-posta veya parola hatalı.',

  // ---------------------------------------------------------------- visit types
  'visitTypes.title': 'Denetim Ziyaret Tipleri',
  'visitTypes.subtitle': 'Denetimin hangi konu üzerine olduğunu belirler. Şablon oluştururken seçilir.',
  'visitTypes.name': 'Ad',
  'visitTypes.namePlaceholder': 'Ziyaret tipi adı',
  'visitTypes.description': 'Açıklama',
  'visitTypes.templates': 'Şablon',
  'visitTypes.empty': 'Henüz ziyaret tipi tanımlanmadı.',
  'visitTypes.inUse': '{count} şablon',
  'visitTypes.unused': 'kullanılmıyor',

  // ---------------------------------------------------------------- categories
  'categories.title': 'Kategoriler',
  'categories.subtitle':
    'Soru başlıkları. Kod, soru kodlarının ön eki olarak kullanılır — Görsel Operasyon → GOR-01.',
  'categories.name': 'Kategori',
  'categories.namePlaceholder': 'Kategori adı',
  'categories.code': 'Kod',
  'categories.description': 'Açıklama',
  'categories.questions': 'Soru',
  'categories.questionCount': '{count} soru',
  'categories.empty2': 'boş',
  'categories.empty': 'Henüz kategori tanımlanmadı.',
  'categories.inUseTitle': 'Kullanımda, silinemez',

  // ---------------------------------------------------------------- questions
  'questions.title': 'Sorular',
  'questions.subtitle': '{count} soru · şablonlar buradan seçiyor',
  'questions.search': 'Soru veya kod ara…',
  'questions.allCategories': 'Tüm kategoriler',
  'questions.category': 'Kategori',
  'questions.code': 'Kod',
  'questions.text': 'Soru',
  'questions.type': 'Tip',
  'questions.behaviour': 'Davranış',
  'questions.usage': 'Kullanım',
  'questions.usedIn': '{count} şablon',
  'questions.unused': 'kullanılmıyor',
  'questions.empty': 'Bu filtreye uyan soru yok.',
  'questions.needCategory': 'Önce en az bir kategori tanımlanmalı — soru kodu kategorinin ön ekinden türüyor.',
  'questions.retired': 'emekli',
  'questions.inUseTitle': 'Şablonlarda kullanılıyor',

  'questions.editTitle': 'Soruyu Düzenle',
  'questions.newTitle': 'Soru Tanımla',
  'questions.codeHint': 'Kategoriye göre önerildi, değiştirebilirsin.',
  'questions.textPlaceholder': 'Denetmenin ekranda okuyacağı cümle',
  'questions.guidance': 'Soru Açıklaması',
  'questions.guidancePlaceholder': "Neye bakılacağını anlatır. Denetmen 'Açıklamayı gör' ile açar.",
  'questions.scaleMaximum': 'Maksimum Değer',
  'questions.scaleHint': 'Denetmen 1 ile {max} arasında seçer. Puan = ağırlık × seçilen ÷ {max}.',
  'questions.scoring': 'Puanlama davranışı',
  'questions.scoringHint': 'Puanlama motorunun soru bazlı kuralları.',
  'questions.critical': 'Kritik madde',
  'questions.commentRequirement': 'Yorum zorunluluğu',
  'questions.photoRequirement': 'Fotoğraf zorunluluğu',
  'questions.allowNotApplicable': 'Denetmen "uygulanamaz" işaretleyebilir',
  'questions.notApplicableRule': 'Uygulanamaz işaretlenirse puanı kategorideki diğer sorulara, puanları oranında dağılır; kategori puanı değişmez. Kategorinin bütün soruları uygulanamaz olursa kategori düşer ve puanı diğer kategorilere oranla dağılır — toplam her zaman 100.',

  'chip.criticalForm': 'kritik · denetim',
  'chip.criticalCategory': 'kritik · kategori',
  'chip.comment': 'yorum',
  'chip.photo': 'foto',
  'chip.notApplicableForm': 'N/A · form',
  'chip.notApplicableCategory': 'N/A · kategori',

  // ---------------------------------------------------------------- enumerations
  'answerType.YesNo': 'Evet / Hayır',
  'answerType.Scale': 'Slider',
  'critical.None': 'Yok',
  'critical.Category': 'Kategoriyi sıfırlar',
  'critical.Form': 'Denetimi sıfırlar',
  'trigger.Never': 'Hiçbir zaman',
  'trigger.WhenNegative': 'Olumsuz cevapta',
  'trigger.Always': 'Her cevapta',
  'naScope.Category': 'Kategori içinde dağılır',
  'naScope.Form': 'Formdan düşer',

  // ---------------------------------------------------------------- errors
  'error.category.name.required': 'Kategorinin bir adı olmalı.',
  'error.category.code.length': "'{code}' ön ek olarak kullanılamaz: iki ile altı harf arası olmalı. Bu kod basılı kontrol listelerine yazılıyor ve mağazada sesli okunuyor.",
  'error.category.code.letters-only': "'{code}' yalnızca harf içerebilir — soru kodu tiresinden ayrıştırılıyor, ön ekteki rakam bunu belirsiz hâle getirir.",

  'error.question.code.required': 'Sorunun bir kodu olmalı. Denetmenin mağazada okuduğu şey o.',
  'error.question.text.required': 'Sorunun metni boş olamaz.',
  'error.question.category.required': 'Soru bir kategoriye ait olmalı.',
  'error.question.critical.text': "'{question}' serbest metin: kalacak bir cevabı yok, o yüzden kritik olamaz.",
  'error.question.options.duplicate': "'{option}' iki kez yazılmış. Seçenekler birbirinden farklı olmalı.",
  'error.code.too-long': 'Kod en fazla {max} karakter olabilir.',
  'error.closed-day.date.required': 'Geçerli bir tarih seçin.',
  'error.question.critical-and-skippable':
    "'{question}' uygulanamaz işaretlenebiliyor, bu yüzden kritik de olamaz. Önce uygulanamaz seçeneğini kapat, ya da soruyu kritik yapma.",
  'error.question.skippable-and-critical':
    "'{question}' kritik bir kontrol, atlanabilir yapılamaz. Önce kritik ayarını kaldır.",
  'error.question.scale.not-a-scale': 'Maksimum değer yalnızca slider sorularında anlamlı.',
  'error.question.scale.too-small': 'Skala en az 2 puan olmalı; tek puanlık skala uzun yoldan evet/hayır sorusudur.',

  'error.visit-type.name.required': 'Ziyaret tipinin bir adı olmalı.',

  'error.library.category.in-use':
    "'{name}' kategorisinde {count} soru var. Silinirse o sorular hiçbir yerden bulunamaz; önce başka bir kategoriye taşıyın.",
  'error.library.question.in-use':
    "'{code}' {count} şablonda kullanılıyor. Silmek yerine emekliye ayırın — böylece sorulmuş olana giden iz kaybolmaz.",
  'error.library.visit-type.in-use':
    "'{name}' {count} şablonda kullanılıyor. Silmek yerine pasife alın; o şablonlar ve onlara göre yapılmış denetimler anlamını korusun.",
  'error.common.duplicate-code': 'Bu kod ya da ad zaten kullanılıyor. Kodlar kiracı içinde benzersiz olmalı.',

  'problem.audit.signature-required': 'Ziyaretin imzalanması gerekiyor.',
  'problem.audit.comment-required': '“{question}” için açıklama gerekiyor.',
  'problem.audit.photo-required': '“{question}” için fotoğraf gerekiyor.',
  'problem.audit.unanswered': '“{question}” cevaplanmamış.',
  'problem.audit.answer.scale-for-yes-no': '“{question}” evet/hayır sorusu ama ölçek değeriyle cevaplanmış.',
  'problem.audit.answer.yes-no-for-scale': '“{question}” ölçek sorusu ama evet/hayır ile cevaplanmış.',
  'problem.audit.answer.out-of-scale': '“{question}” {value} olarak cevaplanmış; ölçeği {min}–{max}.',
  'problem.audit.answer.too-many-options': '“{question}” tek cevap alır, {count} tane verilmiş.',
  'problem.audit.answer.not-text': '“{question}” serbest metin sorusu ve başka bir şekilde cevaplanmış.',
  'problem.audit.answer.unknown-options': '“{question}” sunmadığı {count} seçenekle cevaplanmış.',
  'problem.audit.answer.off-form': 'Formda olmayan bir soru ({question}) için cevap var — form {form}.',
  'problem.audit.not-applicable-refused': '“{question}” bu formda “uygulanmaz” işaretlenemez.',
  'problem.audit.critical-skipped': '“{question}” kritik bir kontrol ve atlanamaz.',
  'problem.form.no-categories': 'Formda hiç kategori yok.',
  'problem.form.category.empty': '“{category}” kategorisinde hiç soru yok.',
  'problem.form.category.no-weight': '“{category}” kategorisinde dağıtılacak soru ağırlığı yok.',
  'problem.form.no-category-weight': 'Puanlı bir formun en azından bir miktar kategori ağırlığı olmalı.',
  'problem.form.points.total': 'Soru puanları {total} ediyor; {target} olmalı.',
  'problem.form.duplicate-question-code': '“{code}” soru kodunu {count} soru birden kullanıyor.',
  'problem.question.too-few-options': '“{question}” bir seçim sorusu ama {count} seçeneği var. İkiden az şey arasında seçim olmaz.',
  'problem.question.options-worth-nothing': '“{question}” seçeneklerinin hepsi sıfır puan; hiçbir zaman puan getiremez.',
  'problem.question.text-cannot-be-critical': '“{question}” serbest metin ve kritik olamaz: değerlendirilecek bir cevap yok, dolayısıyla kalabilecek bir şey de yok.',
  'problem.question.critical-and-optional': '“{question}” hem kritik hem “uygulanmaz” işaretlenebilir. Kritik bir kontrol isteğe bağlı olamaz.',
  'problem.score-bands.leave-a-gap': '{lowest} altındaki puanları hiçbir aralık kapsamıyor.',
  'error.file.key.shape': 'Dosya anahtarı okunamadı. Bir şeyler ters gitti; yöneticinize başvurun.',
  'error.file.kind.unknown': 'Bu türde bir dosya saklanamıyor.',
  'error.file.record.required': 'Dosya bir kayda bağlı olmalı.',
  'error.library.category.not-found': 'Kategori bulunamadı.',

  'error.session.expired': 'Oturum sona erdi.',
  'error.unexpected': 'Beklenmeyen bir hata oluştu.',
  'error.plan.location.required': 'Plan bir mağaza için açılır.',
  'error.plan.form.required': 'Plan bir kontrol listesi için açılır.',
  'error.plan.assignee.required': 'Plan birinin görevidir; atanacak kişi seçilmeli.',
  'error.plan.audit.required': 'Planı başlatmak bir denetim oluşturur.',
  'error.plan.period.backwards': 'Dönem, başladığı tarihten sonra biter.',
  'error.plan.closed': 'Bu plan kapanmış; üzerinde işlem yapılamaz.',
  'error.plan.already-started': 'Bu dönem için bu mağazada açık bir plan zaten var.',
  'error.plan.not-started': 'Plan, başlattığı denetim gönderilince kapanır.',
  'error.plan.cancel.needs-reason': 'Ziyaretin neden yapılmayacağını yazın.',
  'error.plan.assignee.out-of-reach': 'Atanan kişi bu mağazaya erişemiyor; görev listesinde hiç görünmez.',
  'error.plan.assignee.cannot-audit': 'Atanan kişinin denetim yapma yetkisi yok; bu ziyaret hiç yapılamazdı.',
  'error.plan.period.all-closed': 'Dönemin her günü mağazanın kapalı olduğu bir gün.',
  'error.plan.started.fixed': 'Denetim başlamış: kişi ve başlangıç değişmez, yalnız dönem sonu ileri alınabilir.',
  'error.form.not-published': 'Form yayımlanmamış. Yayımlanmamış bir forma plan açılamaz.',
  'error.listFailed': 'Liste alınamadı.',
  'error.saveFailed': 'Kaydedilemedi.',
  'error.deleteFailed': 'Silinemedi.',
  'error.actionFailed': 'İşlem tamamlanamadı.',

  'validation.criticalAndSkippable':
    'Kritik bir madde "uygulanamaz" işaretlenemez — denetmenin atlayabildiği bir kritik kontrol, kritik kontrol değildir.',

  // ---------------------------------------------------------------- organisation
  'app.organisation': 'Organizasyon',
  'app.geography': 'Coğrafya',
  'nav.locationTypes': 'Lokasyon Tipleri',
  'nav.departments': 'Departmanlar',
  'nav.systemParameters': 'Sistem Parametreleri',

  'systemParameters.title': 'Sistem Parametreleri',
  'systemParameters.subtitle': 'Üründe ne olduğunu değil, nasıl davrandığını belirleyen ayarlar.',
  'systemParameters.saved': 'Kaydedildi',
  'systemParameters.scoring': 'Puanlama',
  'systemParameters.scoringHint':
    'Yeni denetim şablonlarının hangi modelle doğacağını belirler.',
  'systemParameters.model': 'Puanlama modeli',
  'systemParameters.modelHint':
    'Ağırlık: sayılar görelidir, kategori payını siz verirsiniz. Puan: her soru kendi puanını taşır, kategori sorularının toplamı kadar eder.',
  'systemParameters.target': 'Toplam puan hedefi',
  'systemParameters.targetHint':
    'Puan modelinde soru puanlarının toplaması gereken sayı. Yayımlarken denetlenir.',
  'systemParameters.onlyNewTemplates':
    'Bu ayar yalnız bundan sonra oluşturulacak şablonları etkiler. Mevcut şablonlar kendi modelini taşır ve verilmiş hiçbir puan değişmez.',
  'systemParameters.showQuestionPoints': 'Soru puanları denetçiye gösterilsin',
  'systemParameters.showQuestionPointsHint':
    'Denetim ekranında her sorunun yanında kaç puan ettiği yazar. Kapatılırsa mağaza hangi sorulara ağırlık verildiğini göremez.',
  'systemParameters.showRunningScore': 'Anlık puan denetçiye gösterilsin',
  'systemParameters.showRunningScoreHint':
    'Denetim sürerken üstteki toplam ve kategori puanları. Yalnız denetim ekranını kapatır — gönderilmiş denetimin puanı listede, raporda ve haritada görünmeye devam eder.',
  'systemParameters.displayTakesEffectNow':
    'Yukarıdaki iki anahtar anında geçerli olur; devam eden denetimlerde de görünür. Puanlama modelinin aksine bunlar şablona işlenmez, çünkü neyin çizileceğini belirler, bir sayının ne anlama geldiğini değil.',

  'scoringModel.Weight': 'Ağırlık',
  'scoringModel.Points': 'Puan',
  'nav.operations': 'Operasyonlar',
  'nav.regions': 'Bölgeler',
  'nav.locations': 'Lokasyonlar',
  'nav.countries': 'Ülkeler',
  'nav.cities': 'Şehirler',
  'nav.districts': 'İlçeler',
  'common.code': 'Kod',
  'common.name': 'Ad',
  'common.description': 'Açıklama',
  'common.status': 'Durum',
  'common.active': 'Aktif',
  'common.inactive': 'Pasif',
  'common.all': 'Tümü',
  'common.locations': 'lokasyon',
  'locationTypes.title': 'Lokasyon Tipleri',
  'locationTypes.subtitle': 'Hangi şablonun nerede doldurulacağını bu belirler — AVM, CADDE, OUTLET.',
  'locationTypes.locations': 'lokasyon',
  'locationTypes.empty': 'Henüz lokasyon tipi yok. Şablonları lokasyona göre süzebilmek için en az bir tane gerekli.',
  'departments.title': 'Departmanlar',
  'departments.subtitle':
    'Şemadaki birimler. Hangisinin merkez olduğunu siz söylersiniz; aksiyon sorumlusu listesi buna bakar.',
  'departments.empty': 'Henüz departman yok.',
  'departments.headOffice': 'Merkez mi',
  'departments.headOfficeShort': 'Merkez',
  'departments.storeShort': 'Mağaza',
  'operations.title': 'Operasyonlar',
  'operations.subtitle': 'Denetim sorumluluğunun en üst seviyesi. Bölgeler buna bağlanır.',
  'operations.regions': 'bölge',
  'operations.empty': 'Henüz operasyon yok.',
  'regions.title': 'Bölgeler',
  'regions.subtitle': 'Bir operasyona bağlıdır, lokasyonlar buna bağlanır.',
  'regions.operation': 'Operasyon',
  'regions.locations': 'lokasyon',
  'regions.empty': 'Bu seçimde bölge yok.',
  'regions.needOperation': 'Önce en az bir operasyon tanımlayın — bölge bir operasyona bağlı olmak zorunda.',
  'countries.title': 'Ülkeler',
  'countries.subtitle': 'Şablonun hangi pazarda geçerli olduğu ve resmî tatil takvimi buna bağlanır.',
  'countries.cities': 'şehir',
  'countries.empty': 'Henüz ülke yok.',
  'cities.title': 'Şehirler',
  'cities.subtitle': 'Bir ülkeye bağlıdır.',
  'cities.country': 'Ülke',
  'cities.districts': 'ilçe',
  'cities.empty': 'Bu seçimde şehir yok.',
  'cities.needCountry': 'Önce en az bir ülke tanımlayın.',
  'districts.title': 'İlçeler',
  'districts.subtitle': 'Bir şehre bağlıdır.',
  'districts.city': 'Şehir',
  'districts.empty': 'Bu seçimde ilçe yok.',
  'districts.needCity': 'Önce en az bir şehir tanımlayın.',
  'locations.notANumber': 'Sayı değil. Ondalık için nokta ya da virgül kullanın.',
  'locations.notAPhone': 'Telefon numarası değil. Rakam, boşluk, +, ( ) ve - kullanın.',
  'locations.missing': 'Kaydetmek için: {fields}',
  'locations.title': 'Lokasyonlar',
  'locations.subtitle': 'Denetlenen yerler. Denetim bir lokasyona açılır — buradaki kayıtlar olmadan denetim başlatılamaz.',
  'locations.newTitle': 'Yeni lokasyon',
  'locations.editTitle': 'Lokasyonu düzenle',
  'locations.type': 'Lokasyon Tipi',
  'locations.region': 'Bölge',
  'locations.country': 'Ülke',
  'locations.city': 'Şehir',
  'locations.district': 'İlçe',
  'locations.address': 'Adres',
  'locations.phone': 'Telefon',
  'locations.coordinates': 'Konum',
  'locations.latitude': 'Enlem',
  'locations.longitude': 'Boylam',
  'locations.area': 'Metrekare',
  'locations.openedOn': 'Açılış Tarihi',
  'locations.isActive': 'Planlamaya dahil',
  'locations.isActiveHint': 'Kapatılan lokasyon planlamadan çıkar, denetim geçmişi yerinde kalır.',
  'locations.whoAnswers': 'Kim sorumlu',
  'locations.whoAnswersHint': 'Lokasyon tipi hangi şablonun doldurulacağını, bölge kimin cevap vereceğini belirler.',
  'locations.whereItStands': 'Nerede',
  'locations.checkIn': 'Check-in',
  'locations.checkInHint': 'Denetçinin mağazada olduğunun ölçüldüğü nokta. Boşsa sistem bunu varsaymak zorunda kalır.',
  'locations.noType': 'tip yok',
  'locations.noCoordinates': 'konum yok',
  'locations.auditedCannotDelete': '{count} denetim bu lokasyona ait — silinemez, kapatılır.',
  'locations.empty': 'Henüz lokasyon yok. Denetim akışı buradan başlıyor.',
  'error.country.name.required': 'Ülkenin bir adı olmalı.',
  'error.country.code.length': 'Ülke kodu iki ya da üç harf olmalı — TR, DE.',
  'error.country.code.letters-only': 'Ülke kodu yalnızca harf içerebilir.',
  'error.city.name.required': 'Şehrin bir adı olmalı.',
  'error.city.country.required': 'Şehir bir ülkeye bağlı olmalı.',
  'error.district.name.required': 'İlçenin bir adı olmalı.',
  'error.district.city.required': 'İlçe bir şehre bağlı olmalı.',
  'error.operation.name.required': 'Operasyonun bir adı olmalı.',
  'error.operation.code.required': 'Operasyonun bir kodu olmalı.',
  'error.region.name.required': 'Bölgenin bir adı olmalı.',
  'error.region.operation.required': 'Bölge bir operasyona bağlı olmalı.',
  'error.location-type.name.required': 'Lokasyon tipinin bir adı olmalı.',
  'error.department.name.required': 'Departmanın bir adı olmalı.',
  'error.location.code.required': 'Lokasyonun bir kodu olmalı — raporda görünen şey o.',
  'error.location.name.required': 'Lokasyonun bir adı olmalı.',
  'error.location.city.without-country': 'Şehir seçmek için önce ülke gerekli.',
  'error.location.district.without-city': 'İlçe seçmek için önce şehir gerekli.',
  'error.location.city.not-in-country': '{city}, {country} içinde değil.',
  'error.location.district.not-in-city': '{district}, {city} içinde değil.',
  'error.location.coordinate.half': 'Enlem ve boylam birlikte girilir. Yarım koordinat ekvator üzerinde bir nokta gösterir ve check-in mesafeyi şikâyet etmeden ona göre ölçer.',
  'error.location.latitude.range': 'Enlem -90 ile 90 arasında olmalı.',
  'error.location.longitude.range': 'Boylam -180 ile 180 arasında olmalı.',
  'error.location.area.positive': 'Metrekare sıfırdan büyük olmalı.',
  'error.organisation.country.in-use': "'{name}' {count} kayıt tarafından kullanılıyor. Önce onları taşıyın.",
  'error.organisation.district.in-use': "'{name}' {count} lokasyonda kullanılıyor. Önce onları taşıyın.",
  'error.organisation.city.in-use': "'{name}' {count} kayıt tarafından kullanılıyor. Önce onları taşıyın.",
  'error.organisation.operation.in-use': "'{name}' altında {count} bölge var. Önce onları taşıyın.",
  'error.organisation.region.in-use': "'{name}' altında {count} lokasyon var. Önce onları taşıyın.",
  'error.organisation.location-type.in-use': "'{name}' {count} lokasyonda kullanılıyor. Önce onları değiştirin.",
  'error.organisation.department.in-use': "'{name}' kullanımda.",
  'error.organisation.location.in-use': "'{name}' için {count} denetim yapılmış. Denetimler kanıt ve bu lokasyonu adıyla anıyor — silmek yerine kapatın.",
  'error.organisation.not-found': 'Seçilen kayıt bulunamadı. Liste eski olabilir — sayfayı yenileyin.',

  // ---------------------------------------------------------------- access
  'nav.users': 'Kullanıcılar',
  'nav.roles': 'Roller',

  'app.people': 'İnsan Kaynakları',
  'nav.groups': 'Kullanıcı Grupları',
  'groups.title': 'Kullanıcı Grupları',
  'groups.subtitle': 'Şemayı kesen adlandırılmış kişi kümeleri: raporun süzüldüğü ve bir şeyin topluca verildiği insanlar.',
  'groups.add': 'Grup ekle',
  'groups.newTitle': 'Yeni grup',
  'groups.editTitle': 'Grubu düzenle',
  'groups.members': 'Üyeler',
  'groups.membersHint': 'Bu gruba kimler dahil. Üyelik geçmişi tutulmaz — koltuktaki dönemin aksine, grup bugüne dairdir.',
  'groups.andMore': 've {count} kişi daha',
  'groups.grants': 'Grubun verdiği roller',
  'groups.grantsHint': 'Bu gruba girmek bunları da verir. Rol verir, erişim vermez: erişim koltuğun özelliğidir, yoksa "bu kişi burayı neden görüyor" sorusu yine iki yere dağılır.',
  'groups.grantsWarning': 'Bu roller gruptaki {count} kişinin hepsine birden verilir ve bir sonraki girişlerinde geçerli olur.',
  'groups.noGrants': 'yetki vermiyor',
  'groups.grantsCannotDelete': 'Bu grup {count} rol veriyor',
  'groups.codeHint': 'Sabit kısa ad: ic-denetim.',
  'groups.isActiveHint': 'Kapatılan grup hiçbir yetki vermez; üyeleri yerinde kalır.',
  'groups.empty': 'Henüz grup yok',
  'groups.emptyText': 'Raporu süzmek ya da bir yetkiyi topluca vermek için: İç Denetim Ekibi, Bayi Denetçileri.',
  'error.user-group.name.required': 'Grubun bir adı olmalı.',
  'error.user-group.member.required': 'Üye bir kişidir.',
  'error.user-group.in-use': 'Bu grup rol veriyor. Önce rolleri kaldırın — silmek, gruptaki herkesten aynı anda almak demektir.',


  'nav.professions': 'Meslekler',
  'nav.chart': 'Pozisyonlar',
  'professions.title': 'Meslekler',
  'professions.subtitle': 'Bir mesleğin ne yapabileceği bir kez yazılır; o meslek için açılan her pozisyon onu taşır.',
  'professions.add': 'Meslek ekle',
  'professions.newTitle': 'Yeni meslek',
  'professions.editTitle': 'Mesleği düzenle',
  'professions.grants': 'Verdiği roller',
  'professions.grantsHint': 'Bu meslekten olan herkesin, nerede oturursa otursun yapabilecekleri. Pozisyon bunun üstüne ekleyebilir.',
  'professions.seats': 'Pozisyon',
  'professions.codeHint': 'Sabit kısa ad. Raporlarda ve kayıtlarda bunu görürsünüz.',
  'professions.isActiveHint': 'Kapatılan meslek hiçbir yetki vermez. Pozisyonların erişimi yerinde kalır.',
  'professions.seatedCannotDelete': 'Bu mesleğe bağlı {count} pozisyon var',
  'professions.empty': 'Henüz meslek yok',
  'professions.emptyText': 'Denetçi, Mağaza Müdürü, Bölge Müdürü — şirketteki işlerin adları. Pozisyonlar bunların üzerine kurulur.',
  'chart.title': 'Pozisyonlar',
  'chart.subtitle': 'Organizasyon şemasının koltukları ve kimin oturduğu. Yetki koltuğa aittir: ayrılan kişi bölgesini yanında götürmez, yerine gelen devralır.',
  'chart.add': 'Pozisyon ekle',
  'chart.newTitle': 'Yeni pozisyon',
  'chart.editTitle': 'Pozisyonu düzenle',
  'chart.seat': 'Pozisyon',
  'chart.department': 'Departman',
  'chart.seatTitle': 'Pozisyon adı',
  'chart.codeHint': 'Sabit kısa ad: bm-ege, denetci-04.',
  'chart.professionHint': 'Hangi işin koltuğu. Mesleğin verdiği roller buraya kendiliğinden gelir.',
  'chart.holder': 'Oturan',
  'chart.vacant': 'Boş',
  'chart.vacantCount': '{count} boş',
  'chart.since': '{date} tarihinden beri',
  'chart.reach': 'Erişim',
  'chart.reachHint': 'Bu koltuğun organizasyonun hangi parçasını gördüğü. Oturan kişi tam olarak bunu görür.',
  'chart.reachNone': 'Henüz bir şey seçilmedi. Erişimi olmayan bir koltukta oturan kişi hiçbir mağaza göremez.',
  'chart.reachGlobalHint': 'Her yer seçili. Yanına tek bir bölge eklenemez — önce bunu kaldırın.',
  'chart.everywhere': 'Her yer',
  'chart.addEverywhere': 'Her yeri ekle',
  'chart.addOperation': 'Operasyon ekle',
  'chart.addRegion': 'Bölge ekle',
  'chart.addLocation': 'Mağaza ekle',
  'chart.removeReach': '{name} erişimini kaldır',
  'chart.scope.Global': 'Her yer',
  'chart.scope.Operation': 'Operasyon',
  'chart.scope.Region': 'Bölge',
  'chart.scope.Location': 'Mağaza',
  'chart.grants': 'Pozisyonun verdiği roller',
  'chart.grantsHint': 'Mesleğin verdiklerinin üstüne. Yalnız bu koltuğa özel bir şey varsa işaretleyin.',
  'chart.reportsTo': 'Bağlı olduğu',
  'chart.reportsToHint': 'Kişiye değil koltuğa bağlanır — müdür ayrıldığında altındakiler aynı koltuğa bağlı kalır.',
  'chart.top': 'En üst',
  'chart.isActiveHint': 'Kapatılan pozisyon ne yetki ne erişim verir, ama geçmişi durur.',
  'chart.headcount': 'Norm kadro',
  'chart.headcountHint': 'Departman başına dolu / toplam koltuk. Boş koltuk bir eksiklik değil, görünür bir ihtiyaçtır.',
  'chart.total': 'Toplam',
  'chart.seatSomebody': 'Birini oturt',
  'chart.unseated': 'Koltuğu olmayanlar',
  'chart.seatedElsewhere': 'Başka koltukta oturanlar',
  'chart.seatConfirm': 'Oturt',
  'chart.from': 'Başlangıç tarihi',
  'chart.fromHint': 'Bu kişinin koltuktaki ilk günü. Geçmişe tarih verebilirsin — şema, insanlar çoktan işe başladıktan sonra kuruluyor.',
  'chart.handover': 'Devret',
  'chart.handoverConfirm': 'Devret',
  'chart.handoverHint': '{title} koltuğu {name} kişisinden kime geçiyor? Tek adımda olur: öncekinin son günü, sonrakinin ilk gününden bir önceki gündür.',
  'chart.handoverFrom': 'Devir tarihi',
  'chart.handoverFromHint': 'Yeni kişinin ilk günü. Önceki kişinin dönemi bir gün öncesinde kapanır — ne boşluk kalır ne de çakışma.',
  'error.holder.overlaps': 'Bu koltukta o tarihi kapsayan başka bir dönem var. Bir koltukta aynı anda tek kişi oturur — geçmişte de bugün olduğu kadar.',
  'error.holder.handover-too-early': 'Mevcut dönem {from} tarihinde başlamış, yani henüz devredilecek bir şey yok. Oturtmayı kaldır — yanlış bir atama geçmiş değildir.',
  'chart.seatHint': '{title} koltuğuna kim oturacak?',
  'chart.seatExplains': 'Oturduğu anda bu koltuğun yetkilerini ve erişimini alır. Ayrı bir atama yapmanız gerekmez; bir sonraki girişinde geçerli olur.',
  'chart.person': 'Kişi',
  'chart.alreadySeated': '{count} koltukta',
  'chart.vacate': 'Koltuktan kaldır',
  'chart.vacateTitle': '{name} koltuktan kalksın mı?',
  'chart.vacateWarning': 'Bu koltuğun verdiği yetki ve erişim o kişiden gider. Geçmişi durur: hangi tarihler arasında oturduğu kayıtlı kalır.',
  'chart.heldCannotDelete': 'Önce koltuktan kaldırın',
  'chart.empty': 'Henüz pozisyon yok',
  'chart.emptyText': 'Her koltuk bir iş: bir meslek, bir departman, organizasyonun bir parçası. Koltuk sayısı norm kadronuzdur.',
  'error.chart.profession.in-use': 'Bu mesleğe bağlı pozisyonlar var. Önce onları başka bir mesleğe taşıyın.',
  'error.chart.position.in-use': 'Bu pozisyonun geçmişi ya da ona bağlı pozisyonlar var. Silmek yerine kapatın.',
  'error.position.already-held': 'Bu koltukta zaten biri oturuyor. Şema koltuk sayar, sandalye değil.',
  'error.position.reports-to.itself': 'Bir pozisyon kendisine bağlanamaz.',
  'error.position.reports-to.loop': 'Bu, pozisyonu aradakiler üzerinden kendi altına koyardı.',
  'error.position.reach.already-global': 'Bu pozisyon zaten her yere erişiyor. Tek bir parça eklemeden önce onu kaldırın.',
  'error.position.title.required': 'Pozisyonun bir adı olmalı.',
  'error.position.department.required': 'Pozisyon bir departmanda oturur.',
  'error.position.profession.required': 'Pozisyon bir mesleğin koltuğudur.',
  'error.profession.name.required': 'Mesleğin bir adı olmalı.',
  'error.holder.position.required': 'Birinin bir şeyde oturuyor olması gerekir.',
  'error.holder.user.required': 'Koltukta biri oturur.',
  'error.holder.ends-before-start': 'Bir koltuktaki dönem başlamadan bitemez.',

  'permission.definitions.manage': 'Tanımları yönet',
  'permission.definitions.manage.hint': 'Ziyaret tipleri, kategoriler, sorular, lokasyon tipleri, departmanlar.',
  'permission.organisation.manage': 'Organizasyonu yönet',
  'permission.organisation.manage.hint': 'Ülke, şehir, ilçe, operasyon, bölge ve lokasyonlar.',
  'permission.templates.manage': 'Şablonları yönet',
  'permission.templates.manage.hint': 'Denetimin ölçüldüğü formları kur ve yayınla.',
  'permission.plans.manage': 'Denetim planla',
  'permission.plans.manage.hint': 'Kimin hangi mağazayı ne zaman ziyaret edeceğini belirle; planı değiştir veya iptal et.',
  'permission.audits.conduct': 'Denetim yap',
  'permission.audits.conduct.hint': 'Sahada denetim aç ve doldur.',
  'permission.audits.read': 'Denetimleri oku',
  'permission.audits.read.hint': 'Denetimleri ve raporları görüntüle.',
  'permission.actions.respond': 'Aksiyon yanıtla',
  'permission.actions.respond.hint': 'Lokasyona düşen aksiyonları cevapla.',
  'permission.actions.approve': 'Aksiyon onayla',
  'permission.actions.approve.hint': 'Yanıtlanmış aksiyonu onayla — bölge müdürü adımı.',
  'permission.users.manage': 'Kullanıcıları yönet',
  'permission.users.manage.hint': 'Kullanıcı aç, rol tanımla ve dağıt. Kendini verebilen tek yetki.',
  'scope.Country': 'Ülke',
  'scope.Global': 'Tüm kiracı',
  'scope.Operation': 'Operasyon',
  'scope.Region': 'Bölge',
  'scope.Location': 'Lokasyon',
  'roles.title': 'Roller',
  'roles.subtitle': 'Sistemin yapabildikleri sabit; onları kimin yaptığı sizin tanımınız. Her rol bir satır.',
  'roles.key': 'Anahtar',
  'roles.keyHint': 'Token içinde taşınır ve loga düşer; sadece ASCII harf, rakam ve tire. Addan üretilir, yazdıkça düzeltilir.',
  'roles.keyFixed': 'Anahtar değişmez — değişseydi rolü taşıyan herkes sessizce yetkisiz kalırdı.',
  'roles.needsPermission': 'Kaydetmek için en az bir yetki seçin.',
  'roles.permissions': 'Yetkiler',
  'roles.permissionsHint': 'Bu rolü taşıyan kişi tam olarak bunları yapabilir.',
  'roles.holders': 'Taşıyan',
  'roles.everything': 'her şey',
  'roles.builtIn': 'yerleşik',
  'roles.builtInHint': 'Yerleşik rol her yetkiyi taşır ve değiştirilemez. Kendi yetkisini kaldıran bir yönetici, kimsenin geri alamayacağı bir sistem bırakır.',
  'roles.builtInCannotDelete': 'Yerleşik rol silinemez — herkesi yönetebilmeyi sağlayan şey o.',
  'roles.heldCannotDelete': '{count} kişi bu rolü taşıyor. Önce onlardan alın.',
  'roles.isActive': 'Kullanımda',
  'roles.isActiveHint': 'Pasife alınan rol bir sonraki girişte etkisini yitirir; mevcut oturum süresi dolana kadar sürer.',
  'roles.newTitle': 'Yeni rol',
  'roles.editTitle': 'Rolü düzenle',
  'roles.empty': 'Henüz rol yok.',
  'users.title': 'Kullanıcılar',
  'users.subtitle': 'Kim, ne yapabilir, nerede.',
  'users.email': 'E-posta',
  'users.emailHint': 'Giriş bununla yapılır; büyük/küçük harf ayrımı yok.',
  'users.roles': 'Roller',
  'users.noRoles': 'rol yok',
  'users.noRolesHint': 'Ne bir koltuktan, ne bir gruptan, ne de doğrudan rol taşıyor; giriş yapsa hiçbir şey yapamaz.',
  'users.scope.nowhere': 'kapsam yok',
  'users.source.Position': 'Koltuktan geliyor: {through}',
  'users.source.Profession': 'Mesleğinden geliyor: {through}',
  'users.source.Group': 'Gruptan geliyor: {through}',
  'users.source.Direct': 'Doğrudan bu kişiye verilmiş',
  'users.noPassword': 'parola yok',
  'users.locked': 'kilitli',
  'users.manageRoles': 'Rolleri yönet',
  'users.setPassword': 'Parola belirle',
  'users.newPassword': 'Yeni parola',
  'users.passwordHint': 'En az 12 karakter. Uzunluk dışında kural yok — büyük harf ve rakam zorunluluğu, makinenin daha hızlı tahmin ettiği parolalar üretir.',
  'users.initialPassword': 'Başlangıç parolası',
  'users.initialPasswordHint': 'Boş bırakılabilir. Parolası olmayan hesap giriş yapamaz — davet öncesi doğru durum budur.',
  'users.isActive': 'Giriş yapabilir',
  'users.isActiveHint': 'Kapatılan hesap geçmişini korur, bir daha giremez.',
  'users.isHeadOffice': 'Merkez kullanıcısı',
  'users.isHeadOfficeHint':
    'Bu kişiye, departmanına bakılmadan merkezden aksiyon açılabilir. Departmanı hem merkeze hem mağazaya hizmet veriyorsa kullanılacak yol budur. Yetki vermez: cevaplayabilmesi için ayrıca aksiyon cevaplama izni gerekir.',
  'users.headOfficeShort': 'Merkez',
  'users.held': 'Taşıdığı roller',
  'users.heldHint': 'Koltuğundan, mesleğinden, gruplarından ve doğrudan verilenlerin tamamı. Yalnız doğrudan verilen buradan geri alınır — koltuktan geleni kaldırmak için kişiyi koltuktan kaldırmak gerekir.',
  'users.grant': 'Rol ver',
  'users.grantButton': 'Ver',
  'users.revoke': 'Geri al',
  'users.role': 'Rol',
  'users.scope': 'Kapsam',
  'users.scopeHint': '"1. Bölge müdürü kim" sorusunun tek cevabı bu satır. Aynı bilgi iki yerde tutulsaydı zamanla ayrışırdı.',
  'users.noScopeTargets': 'Bu kapsamda henüz tanımlı kayıt yok.',
  'users.effective': 'Sonuçta yapabildikleri',
  'users.effectiveHint': 'Taşıdığı bütün aktif rollerin toplamı — koltuk, meslek, grup ve doğrudan. Bir sonraki girişte token bunu taşır.',
  'users.newTitle': 'Yeni kullanıcı',
  'users.editTitle': 'Kullanıcıyı düzenle',
  'users.empty': 'Henüz kullanıcı yok.',
  'error.role.key.required': 'Rolün bir anahtarı olmalı.',
  'error.role.key.shape': "'{key}' anahtar olarak kullanılamaz: yalnızca ASCII harf, rakam ve tire. Anahtar token içinde taşınıyor ve loga düşüyor; Türkçe harf iki makinede iki farklı karakter oluyor.",
  'error.role.name.required': 'Rolün bir adı olmalı.',
  'error.role.permissions.empty': 'Hiçbir şey yapamayan rol, hiç rol olmamasından ayırt edilemez.',
  'error.role.permissions.unknown': "'{permission}' sistemin yapabildiği bir şey değil.",
  'error.role.system.immutable': "'{name}' yerleşik roldür; yetkileri değiştirilemez ve kapatılamaz.",
  'error.assignment.user.required': 'Atama bir kullanıcıya yapılmalı.',
  'error.assignment.role.required': 'Atama bir rol içermeli.',
  'error.assignment.scope.required': '{scope} kapsamında hangisi olduğu belirtilmeli.',
  'error.assignment.scope.global': 'Tüm kiracı kapsamı zaten her yeri kapsıyor; ayrıca tek bir bölge seçilemez.',
  'error.user.email.required': 'Kullanıcının e-posta adresi olmalı.',
  'error.user.email.shape': "'{email}' bir e-posta adresine benzemiyor.",
  'error.user.name.required': 'Kullanıcının bir adı olmalı.',
  'error.user.password.too-short': 'Parola en az {minimum} karakter olmalı.',
  'error.access.role.in-use': "'{name}' rolünü {count} kişi taşıyor. Önce onlardan alın.",
  'error.access.role.system': "'{name}' yerleşik roldür ve silinemez.",
  'error.access.last-administrator': 'Kullanıcı yönetebilen son hesap bu. Önce başka birine yönetici rolü verin — üründe bunu geri alacak hiçbir yol yok.',
  'error.access.assignment.duplicate': 'Bu rol aynı kapsamda zaten verilmiş.',
  'error.access.user.email-taken': 'Bu e-posta adresi zaten kullanılıyor.',
  'error.access.user.in-use': "'{name}' adına {count} kayıt var. Denetimler kimin yaptığını adıyla söylüyor — silmek yerine hesabı kapatın.",
  'users.delete': 'Kullanıcıyı sil',
  'users.deleteHint': 'Yalnızca henüz hiçbir şey yapmamış bir hesap silinebilir.',

  // ---------------------------------------------------------------- parameters
  'nav.checklistTitles': 'Başlıklar',
  'nav.scoreBands': 'Ziyaret Skorları',
  'nav.actionCompanies': 'Aksiyon Firmaları',
  'nav.centralTeams': 'Merkez Ekipleri',
  'nav.closedDays': 'Kapalı Günler',
  'checklistTitles.title': 'Başlıklar',
  'checklistTitles.subtitle': 'Kontrol listesinin en üst seviyesi. Bir kategori birden fazla başlıkta yer alabilir — İŞ GÜVENLİĞİ hem mağaza denetiminde hem bayi ziyaretinde aynı şeyi ifade ediyor.',
  'checklistTitles.categories': 'Kategoriler',
  'checklistTitles.someCategories': '{count} kategori · {questions} soru',
  'checklistTitles.noCategories': 'kategori seç',
  'checklistTitles.pickHint': 'Bu başlık seçildiğinde şablon tasarımcısına önce bu kategoriler gösterilir. Hiçbir şey yasaklanmıyor — kütüphanenin tamamına yine ulaşılabiliyor.',
  'checklistTitles.questions': '{count} soru',
  'checklistTitles.noLibrary': 'Henüz kategori yok. Önce Kategoriler ekranından ekleyin.',
  'checklistTitles.empty': 'Henüz başlık yok.',
  'scoreBands.title': 'Ziyaret Skorları',
  'scoreBands.subtitle': 'Puanın yanında yazan harf. Her aralık yalnızca alt sınırını söyler — bu yüzden iki aralık aynı puana sahip çıkamaz ve aralarında boşluk kalamaz.',
  'scoreBands.code': 'Kod',
  'scoreBands.from': 'Alt sınır',
  'scoreBands.colour': 'Renk',
  'scoreBands.covers': 'Kapsadığı',
  'scoreBands.range': '{from} – {until}',
  'scoreBands.andAbove': '{from} ve üzeri',
  'scoreBands.empty': 'Henüz skor aralığı yok. Raporlar puanın yanına harf yazamaz.',
  'actionCompanies.title': 'Aksiyon Firmaları',
  'actionCompanies.subtitle': 'Aksiyonun yönlendirilebileceği dış firmalar. Her bulgu mağazanın düzelteceği bir şey değil.',
  'actionCompanies.addresses': 'E-posta',
  'actionCompanies.noAddresses': 'adres yok',
  'actionCompanies.empty': 'Henüz aksiyon firması yok.',
  'centralTeams.title': 'Merkez Ekipleri',
  'centralTeams.subtitle': 'Raporların süzüldüğü merkez ekipleri. Departmandan farkı: departman bulguyu sahiplenir, merkez ekibi raporu dilimler.',
  'centralTeams.empty': 'Henüz merkez ekibi yok.',
  'closedDays.title': 'Kapalı Günler',
  'closedDays.subtitle': 'Planlamanın okuduğu takvim. Kapalı bir güne verilen ziyaret denetçinin gününü boşa harcar; olmamış bir denetim de sonradan atlanmış denetimden ayırt edilemez.',
  'closedDays.calendar': 'Takvim',
  'closedDays.countryCalendar': 'Ülke kapalı günleri',
  'closedDays.locationCalendar': 'Lokasyon kapalı günleri',
  'closedDays.date': 'Tarih',
  'closedDays.reason': 'Neden',
  'closedDays.empty': 'Bu takvimde kayıt yok.',
  'closedDays.needCountry': 'Önce en az bir ülke tanımlayın.',
  'closedDays.needLocation': 'Önce en az bir lokasyon tanımlayın.',
  'error.checklist-title.name.required': 'Başlığın bir adı olmalı.',
  'error.score-band.code.required': 'Aralığın bir kodu olmalı — raporda yazan harf o.',
  'error.score-band.name.required': 'Aralığın bir adı olmalı.',
  'error.score-band.from.out-of-scale': 'Alt sınır 0 ile 100 arasında olmalı; her form bu skalada puanlanıyor. {from} bu skalada değil.',
  'error.score-band.colour': "'{colour}' bir renk değil. Altı onaltılık basamak, örnek: #1B7F4A.",
  'error.action-company.name.required': 'Firmanın bir adı olmalı.',
  'error.action-company.address': "'{email}' bir e-posta adresine benzemiyor.",
  'error.central-team.name.required': 'Ekibin bir adı olmalı.',
  'error.closed-day.name.required': 'Kapalı günün bir nedeni yazılmalı — yanında gerekçe olmayan bir tarihi, gelecek yıl biri ne sildiğini bilmeden siler.',
  'error.closed-day.scope.required': '{scope} kapalı gününde hangisi olduğu belirtilmeli.',
  'error.parameters.score-band.duplicate': '{from} puanında zaten bir aralık başlıyor. İkisi olsaydı harf, hangi satırın önce geldiğine bağlı olurdu.',
  'error.parameters.closed-day.duplicate': '{date} burada zaten kapalı işaretli.',
  'error.parameters.checklist-title.in-use': "'{name}' kullanımda.",
  'error.parameters.score-band.in-use': "'{name}' kullanımda.",
  'error.parameters.action-company.in-use': "'{name}' {count} aksiyonda kullanılıyor.",
  'error.parameters.central-team.in-use': "'{name}' kullanımda.",
  'templates.checklistTitle': 'Başlık',
  'templates.scope': 'Nerede geçerli',
  'templates.scopeHint': 'Hiçbiri seçilmezse her yerde geçerli. Daraltmak bilerek yapılan bir şey — tipi girilmemiş bir mağazada daraltılmış şablon çıkmaz.',
  'templates.countries': 'Ülkeler',
  'templates.locationTypes': 'Lokasyon tipleri',
  'templates.everyCountry': 'her ülke',
  'templates.everyLocationType': 'her tip',
  'templates.noCountries': 'Henüz ülke tanımlı değil.',
  'templates.noLocationTypes': 'Henüz lokasyon tipi tanımlı değil.',
  'error.organisation.location.closed': "'{code}' kapalı. Kapalı lokasyonda denetim açılmaz.",
  'templates.everywhere': 'her yerde',

  // ---------------------------------------------------------------- answer types
  'answerType.SingleChoice': 'Dinamik Seçenek',
  'answerType.MultipleChoice': 'Çoktan Seçme',
  'answerType.Text': 'Metin',
  'questions.options': 'Seçenekler',
  'questions.optionText': 'Seçenek metni',
  'questions.optionCount': '{count} seçenek',
  'questions.addOption': '+ Seçenek ekle',
  'questions.needTwoOptions': 'En az iki seçenek gerekli — ikiden az şey arasından seçim yapılmaz.',
  'questions.optionsSingleHint': 'Tek seçenek işaretlenir ve sorunun yüzde kaçını kazandırdığını kendisi söyler. Diğer seçeneklerin değeri sonucu etkilemez.',
  'questions.optionsMultipleHint': 'Birden fazla işaretlenebilir. Soru, listenin işaretlenen payını kazandırır — dört eşit seçenekten üçü işaretliyse yüzde 75.',
  'error.option.text.required': 'Seçeneğin metni olmalı.',
  'error.option.score.range': 'Seçenek, sorunun yüzde 0 ile 100 arasında bir kısmını kazandırır. {score} bu aralıkta değil.',
  'error.question.options.wrong-type': '{type} tipindeki soruda seçenek listesi olmaz.',
  'error.question.weight.text': 'Metin sorusu hiç puanlanmaz, bu yüzden ağırlık taşımaz.',

  // ---------------------------------------------------------------- the field
  'nav.audits': 'Denetimler',

  'app.reports': 'Raporlar',
  'nav.mailSettings': 'Mail Gönderim Ayarları',
  'mail.title': 'Mail Gönderim Ayarları',
  'mail.subtitle': 'Bir ziyaret gönderildiğinde raporun kimlere gideceği. Ziyaret tipi başına ayrı liste.',
  'mail.visitType': 'Ziyaret tipi',
  'mail.visitTypeHint': 'Her ziyaret tipinin kendi listesi vardır. Parantezdeki sayı mevcut adres sayısıdır.',
  'mail.to': 'To listesi',
  'mail.toHint': 'Raporun doğrudan gönderileceği adresler.',
  'mail.cc': 'Cc listesi',
  'mail.ccHint': 'Bilgi için kopyalanacak adresler. To listesindeki bir adres buradan düşer.',
  'mail.add': 'Ekle',
  'mail.placeholder': 'ad.soyad@firma.com.tr',
  'mail.invalid': "'{address}' bir e-posta adresine benzemiyor.",
  'mail.unsaved': 'Kaydedilmedi',
  'mail.none': 'Liste boş.',
  'mail.saved': 'Kaydedildi',
  'mail.sendsNothing': 'Bu ziyaret tipi için mail gönderilmez.',
  'mail.noVisitTypes': 'Ziyaret tipi yok',
  'mail.noVisitTypesText': 'Önce Tanımlar → Ziyaret Tipleri ekranından en az bir tip tanımlayın.',
  // ---------------------------------------------------------------- the map
  'nav.locationMap': 'Türkiye Haritası',
  'map.title': 'Türkiye Haritası',
  'map.subtitle': 'Bütün lokasyonlar tek ekranda. İller son ziyaret puanlarının ortalamasına göre boyanır; bir noktanın üzerine gelince o lokasyonun göstergeleri çıkar.',
  'map.refresh': 'Yenile',
  'map.stores': 'Lokasyon',
  'map.visited': 'Ziyaret edilmiş',
  'map.averageScore': 'Ortalama puan',
  'map.openActions': 'Açık aksiyon',
  'map.overdueActions': 'Geciken aksiyon',
  'map.legend': 'Skor',
  'map.dots': 'Noktalar',
  'map.dotVisited': 'Ziyaret edilmiş',
  'map.dotOverdue': 'Geciken aksiyonu var',
  'map.dotUnvisited': 'Hiç ziyaret edilmemiş',
  'map.rowHint': 'Bir satıra tıklayınca o mağazanın ziyaret sonuçlarına gidersiniz.',
  'map.code': 'Kod',
  'map.name': 'Mağaza',
  'map.district': 'İlçe',
  'map.locationType': 'Tip',
  'map.score': 'Puan',
  'map.clickToList': 'hepsi için tıklayın',
  'map.storeCount': '{count} mağaza',
  'map.storesOf': '{name} mağazaları',
  'map.unscored': 'Ziyaret yok (mağaza sayısına göre)',
  'map.zoomIn': 'Yakınlaştır',
  'map.zoomOut': 'Uzaklaştır',
  'map.reset': 'Haritayı sıfırla',
  'map.howTo': 'Tekerlek veya iki parmakla yakınlaştırın, sürükleyerek gezin, ile tıklayın. Çift tıklama sıfırlar.',
  'map.noStore': 'Lokasyon yok',
  'map.never': 'Hiç ziyaret edilmedi',
  'map.firstVisit': 'İlk ziyaret',
  'map.lastVisit': 'Son ziyaret',
  'map.trend': 'Gidişat',
  'map.thisYear': 'Bu yıl',
  'map.openWithOverdue': '{open} ({overdue} geciken)',
  'map.visitsAndAverage': '{count} ziyaret · ort. {average}',
  'map.noneThisYear': 'Bu yıl ziyaret yok',
  'map.andMore': '+{count} tane daha',
  'map.clickToSpread': 'Tek tek görmek için ile tıklayın.',
  'map.unplaced': 'Şehri haritada eşleşmeyen {count} lokasyon haritada gösterilmiyor:',

  'nav.mapSettings': 'Harita Göstergeleri',
  'mapSettings.title': 'Harita Göstergeleri',
  'mapSettings.subtitle': 'Haritada bir lokasyonun üzerine gelindiğinde hangi göstergelerin, hangi sırayla görüneceği.',
  'mapSettings.saved': 'Kaydedildi',
  'mapSettings.noneShown': 'Hiçbir gösterge seçili değil. Lokasyon kartı yalnızca kod ve adı gösterir.',
  'mapSettings.moveUp': 'Yukarı taşı',
  'mapSettings.moveDown': 'Aşağı taşı',
  'mapSettings.kpi.LastVisit': 'Son ziyaret',
  'mapSettings.kpiHint.LastVisit': 'Son ziyaretin tarihi, puanı ve harfi.',
  'mapSettings.kpi.OpenActions': 'Açık aksiyonlar',
  'mapSettings.kpiHint.OpenActions': 'Kaç aksiyon açık ve kaçı termini geçmiş.',
  'mapSettings.kpi.Trend': 'Gidişat',
  'mapSettings.kpiHint.Trend': 'Puanın aynı tipteki önceki ziyarete göre nereye gittiği.',
  'mapSettings.kpi.YearToDate': 'Bu yıl',
  'mapSettings.kpiHint.YearToDate': 'Bu yıl yapılan ziyaret sayısı ve ortalaması.',

  'error.map.kpi.order.out-of-range': 'Gösterge sırası 0 ile 99 arasında olmalı.',

  // ---------------------------------------------------------------- planning
  'nav.tasks': 'Görevlerim',
  'tasks.title': 'Görevlerim',
  'tasks.subtitle': 'Size atanmış ziyaretler. Dönemi en yakın olan üstte.',
  'tasks.empty': 'Bekleyen göreviniz yok',
  'tasks.emptyText': 'Size bir ziyaret atandığında burada görünür ve tek tıkla başlatabilirsiniz.',
  'tasks.overdue': 'Gecikti',
  'tasks.overdueCount': '{count} gecikmiş',
  'tasks.started': 'Başlandı',
  'tasks.form': 'Form',
  'tasks.period': 'Dönem',
  'tasks.plannedBy': 'Planlayan',
  'tasks.start': 'Ziyareti başlat',
  'tasks.continue': 'Devam et',
  'tasks.foot': 'Dönemi geçen ziyaretler kaçırıldı olarak kapanır ve plan uyum raporuna düşer.',

  'nav.plans': 'Denetim Planı',
  'plans.title': 'Denetim Planı',
  'plans.subtitle': 'Hangi mağazaya kimin, ne zamana kadar gideceği. Toplu atama yapılır.',
  'plans.new': 'Plan oluştur',
  'plans.choose': 'Seçiniz',
  'plans.form': 'Denetim formu',
  'plans.noPublishedForm': 'Yayımlanmış form şablonu yok, bu yüzden liste boş. Tanımlar → Denetim Formu Şablonları ekranından bir şablonu yayımlayın; plan yalnızca yayımlanmış forma açılır.',
  'plans.formHint': 'Yayımlanmış form şablonları. Taslak forma plan açılmaz.',
  'plans.assignedTo': 'Atanan',
  'plans.from': 'Dönem başlangıcı',
  'plans.to': 'Dönem bitişi',
  'plans.periodHint': 'Ziyaret bu aralıkta yapılır. Habersiz ziyaret güne sabitlenmez.',
  'plans.note': 'Not',
  'plans.noteHint': 'İsteğe bağlı. Atanan kişiye mailde de gider.',
  'plans.stores': 'Mağazalar ({count} seçili)',
  'plans.search': 'Kod veya ad ara',
  'plans.selectShown': 'Görünenleri seç',
  'plans.clear': 'Temizle',
  'plans.notify': 'Atanan kişiye mail gönder',
  'plans.create': '{count} plan oluştur',
  'plans.refused': '{count} mağaza planlanamadı:',
  'plans.tally.planned': 'Planlanan',
  'plans.tally.completed': 'Tamamlanan',
  'plans.tally.overdue': 'Geciken',
  'plans.tally.missed': 'Kaçırılan',
  'plans.tally.rate': 'Uyum oranı',
  'plans.tally.byAuditor': 'Denetçiye göre',
  'plans.tally.from': 'Uyum dönemi — başlangıç',
  'plans.tally.to': 'Bitiş',
  'plans.tally.periodHint': 'Dönemi bu aralığa değen planlar sayılır. Açılışta içinde bulunulan ay gelir; yeni planladığınız dönemi görmek için ileri alın.',
  'plans.tally.none': 'Bu dönemde plan yok.',
  'plans.location': 'Mağaza',
  'plans.period': 'Dönem',
  'plans.status': 'Durum',
  'plans.status.Planned': 'Planlandı',
  'plans.status.Started': 'Başlandı',
  'plans.status.Completed': 'Tamamlandı',
  'plans.status.Missed': 'Kaçırıldı',
  'plans.status.Cancelled': 'İptal',
  'plans.empty': 'Plan yok',
  'plans.emptyText': 'Plan oluştur düğmesiyle bir kontrol listesini mağazalara ve bir kişiye atayın.',
  'plans.cancelPlan': 'Planı iptal et',
  'plans.created': '{count} plan oluşturuldu',
  'plans.cancelTitle': 'Plan iptal edilsin mi: {location}',
  'plans.cancelConfirm': 'Planı iptal et',
  'plans.onlyPeriod': 'Yalnız seçilen dönem',
  'plans.editPlan': 'Planı düzenle',
  'plans.editTitle': 'Planı düzenle — {location}',
  'plans.editStarted': 'Denetim başlamış: kişi ve başlangıç değişmez. Dönem sonunu ileri alabilir, notu değiştirebilirsiniz.',
  'plans.notifyNew': 'Yeni kişiye mail gönder',
  'plans.emptyPeriod': 'Bu dönemde plan yok',
  'plans.emptyPeriodText': 'Başka dönemlerde {count} plan var.',
  'plans.showAllPeriods': 'Bütün dönemleri göster',
  'plans.cancelReason': 'Ziyaret neden yapılmayacak?',
  'plans.truncated': 'Eşleşen plan sayısı gösterilenden fazla. Durum filtresiyle daraltın.',

  'nav.visitResults': 'Ziyaret Sonuç Raporu',
  'nav.followUp': 'Aksiyon Takip Raporu',
  'visits.title': 'Ziyaret Sonuç Raporu',
  'visits.subtitle': 'Gönderilmiş ziyaretler, puanları ve bir önceki ziyarete göre gidişatı.',
  'visits.from': 'Başlangıç tarihi',
  'visits.to': 'Bitiş tarihi',
  'visits.operation': 'Operasyon',
  'visits.region': 'Bölge',
  'visits.locationFilter': 'Lokasyon',
  'visits.locationType': 'Lokasyon tipi',
  'visits.auditor': 'Denetçi',
  'visits.visitType': 'Ziyaret tipi',
  'visits.below': 'Puanı şunun altında',
  'visits.belowHint': 'Boş bırakılırsa hepsi listelenir.',
  'visits.all': 'Tümü',
  'visits.excel': 'Excel',
  'error.exportFailed': 'Excel dosyası üretilemedi.',
  'visits.apply': 'Filtrele',
  'visits.reset': 'Temizle',
  'visits.count': 'Ziyaret',
  'visits.average': 'Ortalama puan',
  'visits.zeroed': 'Kritikten sıfır',
  'visits.belowCount': '{score} altında',
  'visits.location': 'Lokasyon',
  'visits.regionalManager': 'Bölge müdürü',
  'visits.date': 'Tarih',
  'visits.score': 'Alınan puan',
  'visits.previous': 'Önceki ziyaret',
  'visits.firstVisit': 'İlk ziyaret',
  'visits.mail': 'Mail',
  'visits.mail.None': '—',
  'visits.mail.Queued': 'Kuyrukta',
  'visits.mail.Sent': 'Gönderildi',
  'visits.mail.Failed': 'Gönderilemedi',
  'visits.trend': 'Gidişat',
  'visits.trend.Unknown': 'Karşılaştırılacak önceki ziyaret yok',
  'visits.trend.Steady': 'Önceki ziyaretle aynı seviyede',
  'visits.trend.Improved': 'Önceki ziyarete göre yükseldi',
  'visits.trend.Declined': 'Önceki ziyarete göre düştü',
  'visits.empty': 'Sonuç yok',
  'visits.emptyText': 'Seçtiğiniz aralıkta gönderilmiş ziyaret bulunmuyor.',
  'visits.truncated': 'Eşleşen ziyaretlerin tamamı gösterilmiyor. Aralığı daraltın.',

  'grid.columns': 'Kolonlar',
  'grid.filter': 'Süz',
  'grid.all': 'Hepsi',
  'grid.from': 'Başlangıç',
  'grid.to': 'Bitiş',
  'grid.excel': 'Excel',
  'grid.sheetView': 'Görünüm',
  'grid.sheetData': 'Veri',
  'grid.dropHint': 'Gruplamak için bir kolon başlığını buraya sürükle',
  'grid.removeLevel': 'Kaldır',
  'grid.grandTotal': 'Genel toplam',
  'grid.rollUp': 'Toplama türü',
  'grid.aggSum': 'Σ Toplam',
  'grid.aggAvg': 'x̄ Ortalama',
  'grid.aggCount': '# Adet',
  'followUp.title': 'Aksiyon Takip Raporu',
  'followUp.subtitle': 'Denetimden sonra ne oldu: açılan aksiyonlar kapandı mı, zamanında mı, açık kalanlar ne kadar sürüncemede.',
  'followUp.from': 'Başlangıç',
  'followUp.to': 'Bitiş',
  'followUp.dateHint': 'Aksiyonun açıldığı tarihe göre. Açık ve geciken sayılar her zaman bugüne göredir.',
  'followUp.operation': 'Operasyon',
  'followUp.region': 'Bölge',
  'followUp.locationFilter': 'Mağaza',
  'followUp.locationType': 'Mağaza tipi',
  'followUp.all': 'Hepsi',
  'followUp.apply': 'Uygula',
  'followUp.reset': 'Sıfırla',
  'followUp.location': 'Mağaza',
  'followUp.status': 'Durum',
  'followUp.assignee': 'Sorumlu',
  'followUp.finding': 'Bulgu',
  'followUp.category': 'Kategori',
  'followUp.question': 'Soru',
  'followUp.raised': 'Açılış',
  'followUp.due': 'Termin',
  'followUp.overdueDays': 'Gecikme (gün)',
  'followUp.daysToClose': 'Kapanma (gün)',
  'followUp.daysOpen': 'Açık (gün)',
  'followUp.regionalManager': 'Bölge müdürü',
  'followUp.open': 'Açık',
  'followUp.overdue': 'Geciken',
  'followUp.oldest': 'En eski geciken',
  'followUp.oldestHint': 'En uzun süredir geciken aksiyonun kaç gündür geciktiği.',
  'followUp.onTime': 'Zamanında',
  'followUp.avgClose': 'Ort. kapanma',
  'followUp.days': '{n} gün',
  'followUp.openTotal': 'Açık aksiyon',
  'followUp.overdueTotal': 'Geciken',
  'followUp.onTimeRate': 'Zamanında kapanma',
  'followUp.avgCloseDays': 'Ort. kapanma süresi',
  'followUp.unresolvedTotal': 'Çözülemedi',
  'followUp.agingFresh': 'Taze (≤7 gün)',
  'followUp.agingFreshHint': 'Bir hafta veya daha az gecikmiş — hatırlatma bir adım ötede.',
  'followUp.agingAging': 'Sürükleniyor (8–30 gün)',
  'followUp.agingAgingHint': 'Birisi bakmayı bırakmış.',
  'followUp.agingStale': 'Çürümüş (>30 gün)',
  'followUp.agingStaleHint': 'Artık gecikme değil, süreçte bir delik.',
  'followUp.empty': 'Takip edilecek aksiyon yok',
  'followUp.emptyText': 'Seçtiğiniz kapsamda açılmış aksiyon bulunmuyor.',
  'nav.actions': 'Aksiyonlar',
  'raise.open': 'Aksiyon aç',
  'raise.kind': 'Aksiyon türü',
  'raise.kindHint': 'Serbest: sorumlu yaptım deyince kapanır. Onaylı: şablondaki koltuklardan sırayla geçer, son onaycı kapatır.',
  'raise.title': 'Aksiyon aç',
  'raise.confirm': 'Aksiyonu aç',
  'raise.target': 'Kime açılacak',
  'raise.targetHint':
    'Serbest aksiyon merkeze de mağazaya da açılabilir; merkez iki yoldan sorulur, departmandan ya da kişiden. Onaylı aksiyon mağazada kalır: üstündeki onay zinciri o mağazanın kendi zinciri.',
  'raise.targetDepartments': 'Merkez departmanları',
  'raise.targetPeople': 'Merkez kullanıcıları',
  'raise.targetStore': 'Mağaza',
  'raise.noHeadOffice': 'merkez departmanı işaretli değil',
  'raise.noHeadOfficePeople': 'merkez kullanıcısı işaretli değil',
  'raise.nobodySeated': 'Burada oturan kimse yok.',
  'raise.seats': 'Koltuklar',
  'raise.people': 'Kişiler',
  'raise.problemHint': 'Sorumlu bunu okuyacak; denetimi açmak zorunda kalmasın.',
  'raise.problemPlaceholder': 'Üst rafta kutular duruyor, geçişi kapatıyor.',
  'raise.assigneeHint': 'Mağazaya atarsan koltuğa gider: müdür değişse de aksiyon yerinde kalır.',
  'raise.dueHint': 'Termin sizin; sorumlu değiştiremez, yalnız kendi planını yazar.',
  'actions.title': 'Aksiyonlar',
  'actions.subtitle': 'Denetimin geride bıraktığı işler: kime verildi, ne zamana, ne oldu.',
  'actions.mine': 'Bende',
  'actions.awaitingMe': 'Onayımı bekleyen',
  'actions.overdueTab': 'Geciken',
  'actions.all': 'Hepsi',
  'actions.finding': 'Bulgu',
  'actions.problem': 'Ne bulundu',
  'actions.where': 'Nerede',
  'actions.assignee': 'Sorumlu',
  'actions.due': 'Termin',
  'actions.dueOn': 'Termin: {date}',
  'actions.overdue': 'gecikti',
  'actions.raisedBy': '{name} açtı · {date}',
  'actions.response': 'Cevap',
  'actions.responsePlaceholder': 'Ne yapıldı?',
  'actions.plans': 'Planlama geçmişi',
  'actions.newPlan': 'Yeni planlama',
  'actions.newPlanHint': 'Öncekiler silinmez; yanına eklenir. Termin denetçinindir ve değişmez.',
  'actions.plannedFor': 'Planlanan tarih',
  'actions.reason': 'Gerekçe',
  'actions.addPlan': 'Planlamayı ekle',
  'actions.needsNewPlan': 'Termin geçti. Cevaplamadan önce yeni bir planlama tarihi ve gerekçesi girin.',
  'actions.done': 'Yapıldı',
  'actions.cannot': 'Yapılamıyor',
  'actions.chain': 'Onay zinciri',
  'actions.yourDecision': 'Kararınız',
  'actions.note': 'Not',
  'actions.approve': 'Onayla',
  'actions.sendBack': 'Geri gönder',
  'actions.evidence': 'Kanıt dosyaları',
  'actions.evidenceHint': 'Yapılan işi gösteren fotoğraf, fatura ya da irsaliye. Bir sonraki denetimde “yapıldı” sözünün karşılığı budur.',
  'actions.attach': 'Dosya ekle',
  'actions.takePhoto': 'Fotoğraf çek',
  'actions.uploading': 'Yükleniyor: {name} ({size} MB)…',
  'actions.evidenceNone': 'Henüz dosya eklenmedi.',
  'actions.evidenceBy': '{name} · {date}',
  'actions.evidenceOpen': 'Aç',
  'actions.evidenceGone': 'Bu dosya açılamıyor.',
  'actions.sendBackHint': 'Geri gönderirken not zorunlu: sahibi neyi değiştireceğini bilmeli.',
  'actions.empty': 'Aksiyon yok',
  'actions.emptyText': 'Denetim sırasında bir bulgu için aksiyon açıldığında burada görünür.',
  'actions.cannotAnswer': 'cevaplayamaz',
  'actions.kind.Free': 'Serbest',
  'actions.kind.Approved': 'Onaylı',
  'actions.status.Open': 'Açık',
  'actions.status.InApproval': 'Onayda',
  'actions.status.SentBack': 'Geri gönderildi',
  'actions.status.Completed': 'Tamamlandı',
  'actions.status.Unresolved': 'Yapılamadı',
  'actions.decision.Waiting': 'bekliyor',
  'actions.decision.Approved': 'onayladı',
  'actions.decision.SentBack': 'geri gönderdi',
  'error.action.assignee.required': 'Aksiyonun bir sorumlusu olmalı.',
  'error.action.assignee.cannot-answer': 'Seçilen sorumlu aksiyonu cevaplayamaz; bu aksiyon hiç kapatılamazdı.',
  'error.action.assignee.out-of-reach': 'Seçilen sorumlu bu mağazaya erişemiyor; aksiyon listesinde hiç görünmez.',
  'error.action.assignee.not-at-store':
    'Onaylı aksiyon mağazada kalır: üstündeki onay zinciri o mağazanın kendi zinciri. Merkeze iş açmak için serbest aksiyon kullanın.',
  'error.action.assignee.not-listed':
    'Seçilen kişi ne bu mağazada ne de merkez departmanlarında oturuyor. Ona bir koltuk verin ya da departmanını merkez olarak işaretleyin.',
  'error.action.assignee.unchanged': 'Aksiyon zaten bu sorumluda.',
  'error.action.problem.required': 'Ne bulunduğu yazılmalı.',
  'error.action.question.required': 'Aksiyon bir sorudan çıkar.',
  'error.action.audit.required': 'Aksiyon bir denetimden çıkar.',
  'error.action.raiser.required': 'Aksiyonu birisi açar.',
  'error.action.responder.required': 'Cevabı birisi verir.',
  'error.action.response.required': 'Cevap boş bırakılamaz.',
  'error.action.plan.reason.required': 'Tarihin yanında gerekçesi olmalı.',
  'error.action.plan.author.required': 'Bu tarihi birisi verdi.',
  'error.action.step.approver.required': 'Onay adımının bir koltuğu olmalı.',
  'error.action.chain.empty': 'Onaylı aksiyonun en az bir onaycısı olmalı, yoksa hiç kapanmaz.',
  'error.action.chain.unreachable': 'Onay adımlarından biri için bu mağazayı kapsayan koltuk yok; zincir yürütülemiyor.',
  'error.action.chain.ambiguous': 'Onay adımlarından biri için bu mağazayı aynı ölçüde kapsayan birden fazla koltuk var; onaycı belirlenemiyor.',
  'error.action.send-back.needs-note': 'Geri gönderirken neyin eksik olduğunu yazın.',
  'error.action.approver-is-owner': 'Aksiyonu cevaplayan kişi onu onaylayamaz.',
  'error.action.needs-new-plan': 'Termin geçti. Ne zaman yapılacağını ve gerekçesini yazmadan cevaplanamaz.',
  'error.action.not-your-step': 'Bu aksiyon başka bir koltuğu bekliyor.',
  'error.action.wrong-stage': 'Bu aksiyon artık bu adımda değil. Sayfayı yenileyin.',
  'error.action.evidence.key.required': 'Kanıt dosyasının nerede saklandığı yazılmalı.',
  'error.action.evidence.author.required': 'Dosyayı birisi ekledi.',
  'error.mail.recipient.required': 'Mailin gideceği bir adres olmalı.',
  'error.mail.subject.required': 'Konusu olmayan mail okunmaz.',
  'error.mail.body.required': 'Mailin içinde bir şey olmalı.',
  'error.mail.recipients.visit-type.required': 'Alıcı listesi bir ziyaret tipine aittir.',
  'error.mail.address.invalid': "'{address}' bir e-posta adresine benzemiyor.",
  'error.mail.already-sent': 'Bu mail zaten gönderildi.',
  'error.action.evidence.closed': 'Aksiyon kapandı. Eklenen dosyalar, neyin gösterildiğinin kaydıdır.',
  'app.field': 'Saha',
  'audits.title': 'Denetimler',
  'audits.subtitle': 'Senin yaptığın ziyaretler.',
  'audits.start': '+ Denetim başlat',
  'audits.location': 'Lokasyon',
  'audits.form': 'Form',
  'audits.when': 'Tarih',
  'audits.report': 'Rapor (PDF)',
  'error.reportFailed': 'Rapor üretilemedi.',
  'audits.score': 'Puan',
  'audits.questions': 'soru',
  'audits.empty': 'Henüz denetim yok.',
  'audits.noLocations': 'Tanımlı lokasyon yok. Denetim bir lokasyona açılır.',
  'audits.whichForm': 'Hangi form',
  'audits.whichFormHint': 'Bu mağazada bugün geçerli olan kontrol listeleri. Hepsi değil — ülke, lokasyon tipi ve tarih süzüyor.',
  'audits.noneApply': 'Bu mağazada bugün geçerli form yok. Lokasyon tipi girilmemiş olabilir.',
  'audits.criticalFailed': 'kritik',
  'auditStatus.Draft': 'Devam ediyor',
  'auditStatus.Submitted': 'Gönderildi',
  'auditStatus.Appealed': 'İtiraz',
  'auditStatus.Closed': 'Kapandı',
  'audit.notFound': 'Denetim bulunamadı.',
  'audit.saving': 'kaydediliyor',
  'audit.saveFailed': 'kaydedilemedi',
  'audit.submittedOn': '{when} tarihinde gönderildi · puan {score}',
  'audit.notes': 'Ziyaret notu',
  'audit.blocking': 'Gönderime {count} engel var',
  'audit.submit': 'Denetimi gönder',
  'audit.submitWarning': 'Gönderdikten sonra cevaplar değiştirilemez ve rapor dağıtılır. Geri dönüşü yok.',
  'audit.submitScore': 'Hesaplanan puan: {score}',
  'audit.submitConfirm': 'Gönder',
  'audit.backToList': 'Listeye dön',
  'audit.yes': 'Evet',
  'audit.no': 'Hayır',
  'audit.skip': 'Uygulanamaz',
  'audit.unskip': 'Geri al',
  'audit.skipped': 'uygulanamaz',
  'audit.exempt': 'muaf',
  'audit.pointsLeft': '{points} puan formdan düştü',
  'audit.pointsSpread': '{points} puan kategorideki diğer sorulara dağıldı',
  'audit.pointsSpreadForm': 'Kategori uygulanamaz; puanı diğer kategorilere dağıldı',
  'audit.commentWritten': 'Açıklama var',
  'audit.addEvidence': 'Fotoğraf / Video',
  'audit.takePhoto': 'Fotoğraf çek',
  'audit.takeVideo': 'Video çek',
  'audit.fromDevice': 'Dosyadan yükle',
  'audit.videoFromGallery': 'Galeriden video',
  'audit.startRecording': 'Kaydı başlat',
  'audit.stopRecording': 'Kaydı bitir',
  'audit.camera.denied':
    'Kamera izni verilmedi. Tarayıcının adres çubuğundaki izinlerden açabilir ya da dosyadan yükleyebilirsiniz.',
  'audit.camera.none': 'Bu cihazda kullanılabilir bir kamera bulunamadı.',
  'audit.camera.failed': 'Kamera açılamadı. Dosyadan yükleyerek devam edebilirsiniz.',
  'audit.mediaPending': 'Bu dosya henüz gönderilmedi.',
  'audit.mediaExpired': 'Dosya açılamadı; bağlantının süresi dolmuş olabilir.',
  'audit.videoAlt': '{code} · video {n}',
  'audit.commentNeededShort': 'Açıklama gerekli',
  'audit.running': 'Anlık {score}',
  'audit.runningHint':
    'Şu ana kadar verilen cevapların puanı. Denetim bitmeden bu sonuç değildir; kalan sorular sayıyı değiştirir.',
  'audit.worth': '{weight} puan',
  'audit.worthReduced': '{declared} → {effective} puan',
  'audit.categoryRuledOut': '{declared} puan → uygulanamaz',
  'audit.addPhoto': 'Fotoğraf',
  'audit.photoCount': '{count} fotoğraf',
  'audit.photoNeeded': 'Fotoğraf yüklemeniz zorunlu',
  'audit.photoUnavailable': 'açılamıyor',
  'audit.comment': 'Açıklama',
  'audit.commentNeeded': 'zorunlu',
  'audit.guidance': 'Kılavuz',
  'audit.textPlaceholder': 'Gözlemini yaz',
  'audit.unknownType': 'bu soru tipi okunamadı',
  'error.audit.answer.shape': 'Bu soru böyle cevaplanmıyor.',
  'error.audit.incomplete': 'Denetim gönderilmeye hazır değil.',
  'error.audit.not-submitted': 'Taslak denetimin raporu saklanmaz; kaydedilmeden önce gönderilmesi gerekir.',
  'error.report.key.required': 'Saklanan raporun nerede olduğu yazılmalı.',
  'error.audit.not-draft': 'Gönderilmiş denetim değiştirilemez.',
  'error.audit.template.does-not-apply': "'{template}' bugün {location} için geçerli değil.",
  'error.audit.photo.empty': 'Dosya boş.',
  'error.audit.photo.too-large': 'Dosya en fazla {limit} MB olabilir.',
  'error.audit.photo.type': "'{type}' kabul edilen bir fotoğraf veya video türü değil. iPhone kullanıyorsanız: Ayarlar → Kamera → Biçimler → En Uyumlu. Samsung kullanıyorsanız: kamera ayarlarında “Yüksek verimli resimler”i kapatın.",
  'audit.waiting': '{count} bekliyor',
  'audit.unanswered': '{count} soru cevapsız',
  'audit.submitQueued': 'Gönderim sıraya alındı — sinyal gelince gidecek.',
  'audit.rejected': '{count} işlem sunucu tarafından kabul edilmedi',
  'audit.rejectedElsewhere': 'Başka bir denetimde ({audit}) — {reason}',
  'audit.fileNotAdded': 'Dosya eklenmedi',
  'audit.fileNotRead': 'Telefon dosyayı okuyamadı; yeniden seçin.',
  'audit.fileNotStored': 'Dosya cihazda saklanamadı; yeniden seçin.',
  'audit.stuck': '{count} dosya gönderilemedi',
  'audit.stuckHint': 'Ekranda görünüyorlar ama sunucuya ulaşmadılar. Bağlantı düzelince kendiliğinden gönderilirler; denetimi kapatmadan önce buranın temizlendiğinden emin olun.',
  'audit.onlyMissing': 'Eksik {count}',
  'audit.notAnswered': 'Cevaplanmadı',
  'audit.answered': 'Cevaplandı',
  'audit.owesComment': 'Açıklama gerekli',
  'audit.owesPhoto': 'Fotoğraf gerekli',
  'audit.owesBoth': 'Açıklama ve fotoğraf gerekli',
  'templates.signature': 'İmza',
  'templates.signatureNo': 'İmza istenmiyor',
  'templates.signatureYes': 'Ziyaret imzalanır',
  'audit.signature': 'İmza',
  'audit.sign': 'İmzala',
  'audit.signClear': 'Temizle',
  'audit.signAgain': 'Yeniden al',
  'audit.signNeeded': 'imza gerekli',
  'audit.signedBy': 'İmzalayan',
  'audit.signedByHint': 'Ad soyad. Çizimi kimse okuyamaz; okunabilir olan bu.',
  'error.audit.signature.image': 'İmza için çizim gerekli.',
  'error.audit.signature.name': 'İmzalayanın adı yazılmalı. Yanında hiçbir şey olmayan bir çizim kimseyi göstermez.',

  // ---------------------------------------------------------------- shell, renamed
  "nav.mainMenu": "Ana menü",
  "nav.collapse": "Menüyü daralt",
  "nav.expand": "Menüyü genişlet",
  "nav.openMenu": "Menüyü aç",
  "nav.closeMenu": "Menüyü kapat",
  "nav.skipToContent": "İçeriğe atla",
  "theme.label": "Görünüm",
  "theme.system": "Cihaza uy",
  "theme.light": "Açık",
  "theme.dark": "Koyu",

  // ---------------------------------------------------------------- table furniture
  "common.actions": "İşlemler",
  "common.moreActions": "Diğer işlemler",
  "common.search": "Ara",
  "common.saving": "Kaydediliyor…",
  "common.copy": "Kopyala",
  "common.clearFilters": "Filtreleri temizle",
  "common.pageSize": "Sayfa başına",
  "common.pagination": "Sayfalama",
  "common.previousPage": "Önceki sayfa",
  "common.nextPage": "Sonraki sayfa",
  "common.total.one": "Toplam {count} kayıt",
  "common.total.other": "Toplam {count} kayıt",
  "common.shown.one": "{count} kayıt",
  "common.shown.other": "{count} kayıt",
  "common.noResults": "“{term}” için sonuç bulunamadı",
  "common.noResultsText": "Arama metnini kısaltmayı ya da filtreleri temizlemeyi deneyin.",
  "common.loadFailed": "Liste yüklenemedi",
  "common.loadFailedText": "Bağlantı kesilmiş olabilir. Tekrar denemek yeterli.",
  "common.deleteTitle": "{name} silinsin mi?",
  "common.deleteWarning": "Bu işlem geri alınamaz.",
  "common.inUse.one": "{count} kayıtta kullanılıyor.",
  "common.inUse.other": "{count} kayıtta kullanılıyor.",

  // ---------------------------------------------------------------- login
  "login.lead": "Devam etmek için hesap bilgilerinizi girin.",
  "login.required": "E-posta ve parola alanlarının ikisi de dolu olmalı.",
  "login.showPassword": "Parolayı göster",
  "login.hidePassword": "Parolayı gizle",
  "login.help": "Hesabınıza erişemiyorsanız sistem yöneticinizle iletişime geçin.",
  "login.brand.headline": "Her denetim,",
  "login.brand.headlineAccent": "doğru yönde.",
  "login.brand.text": "Mağaza denetimlerini tek bir yerden planlayın, sahada çevrimdışı doldurun, puanı anında görün.",
  "login.brand.foot": "© {year} Norva · Sumo",

  // ---------------------------------------------------------------- behaviour badges
  "badgeCritical.Category": "Kritik · kategori",
  "badgeCritical.Form": "Kritik · denetim",
  "badgeCriticalHint.Category": "Olumsuz cevap bu kategorinin puanını sıfırlar.",
  "badgeCriticalHint.Form": "Olumsuz cevap denetimin tamamını sıfırlar.",
  "badgeNa.Category": "N/A · kategori",
  "badgeNa.Form": "N/A · form",
  "badgeNaHint.Category": "Uygulanamaz işaretlenirse ağırlığı kendi kategorisine dağılır.",
  "badgeNaHint.Form": "Uygulanamaz işaretlenirse ağırlığı formdan tamamen düşer.",
  "badgeComment.WhenNegative": "Yorum · olumsuzda",
  "badgeComment.Always": "Yorum · her zaman",
  "badgeCommentHint.WhenNegative": "Olumsuz cevap verildiğinde yorum zorunlu.",
  "badgeCommentHint.Always": "Her cevapta yorum zorunlu.",
  "badgePhoto.WhenNegative": "Fotoğraf · olumsuzda",
  "badgePhoto.Always": "Fotoğraf · her zaman",
  "badgePhotoHint.WhenNegative": "Olumsuz cevap verildiğinde fotoğraf zorunlu.",
  "badgePhotoHint.Always": "Her cevapta fotoğraf zorunlu.",

  // ---------------------------------------------------------------- photographs
  "image.loading": "Görsel yükleniyor",
  "image.error": "Görsel yüklenemedi. Tekrar denemek için dokunun.",
  "image.open": "Büyüt",

  // ---------------------------------------------------------------- connectivity
  "sync.offline": "Çevrimdışı — değişiklikler cihazda saklanıyor",
  "sync.pending.one": "{count} kayıt gönderilmeyi bekliyor",
  "sync.pending.other": "{count} kayıt gönderilmeyi bekliyor",
  "sync.failed": "Eşitleme başarısız",
  "sync.synced": "Eşitlendi",
  "sync.offlineAction": "Bu işlem çevrimdışı yapılamaz.",
  "visitTypes.searchPlaceholder": "Ziyaret tipi ara…",
  "visitTypes.emptyText": "Ziyaret tipi, bir denetimin hangi amaçla yapıldığını söyler. Şablonlar bunlardan birini seçer.",
  "categories.searchPlaceholder": "Kategori adı veya kodu ara…",
  "categories.emptyText": "Kategoriler soruları gruplar. Puanlama da kategori bazında yapılır.",
  "categories.inUseWarning.one": "Bu kategoride {count} soru var; kategori silinirse onlara erişilemez.",
  "categories.inUseWarning.other": "Bu kategoride {count} soru var; kategori silinirse onlara erişilemez.",
  "questions.add": "Soru ekle",
  "questions.emptyText": "Sorular denetim şablonlarının yapı taşıdır. Bir şablon bu kütüphaneden soru seçer.",
  "questions.optionScore": "Puan",
  "questions.inUseWarning.one": "Bu soru {count} şablonda kullanılıyor.",
  "questions.inUseWarning.other": "Bu soru {count} şablonda kullanılıyor.",
  "templates.add": "Şablon ekle",
  "templates.newTitle": "Yeni şablon",
  "templates.createAndOpen": "Oluştur ve aç",
  "templates.emptyText": "Şablon; ziyaret tipini, soruları ve puanlamayı bir araya getirir. Denetimler şablonlara göre yapılır.",
  "templates.outOfPeriodHint": "Yayında, ama bugün geçerlilik tarihleri dışında.",
  'templates.openToPublish': 'Aç ve yayımla…',
  'templates.draftHint': 'Henüz kullanımda değil. Yayımlamak için şablonu açın — eksikleri de orada görürsünüz.',
  "templates.deleteQuestions.one": "Bu şablonda {count} soru var.",
  "templates.deleteQuestions.other": "Bu şablonda {count} soru var.",
  "audits.emptyText": "Bir lokasyon seçip ona uygun kontrol listesiyle başlayın. Denetim sahada çevrimdışı doldurulabilir.",
  "users.add": "Kullanıcı ekle",
  "users.search": "Ad veya e-posta ara…",
  "users.emptyText": "Kullanıcılar sisteme girer; ne yapabilecekleri verdiğiniz rollere bağlıdır.",
  "users.deleteWarning": "Kullanıcı ve tüm rol atamaları silinir. Yaptığı denetimler kalır.",
  "roles.add": "Rol ekle",
  "roles.emptyText": "Rol, sizin işinize verdiğiniz addır; yetkiler ise ürünün yapabildikleri. İkisini burada eşleştirirsiniz.",
  "locations.add": "Lokasyon ekle",
  "locations.search": "Kod veya ad ara…",
  "locations.emptyText": "Denetim bir lokasyonda yapılır. Lokasyon tipi hangi kontrol listesinin geçerli olduğunu belirler.",
  "audit.photoAlt": "{code} fotoğrafı {n}",
  "templates.noQuestionsText": "Sağdaki kütüphaneden soru seçip ekleyin. Ağırlıkları sonra ayarlayabilirsiniz.",
  "login.unreachable": "Sunucuya ulaşılamadı. Parolanızda bir sorun yok — bağlantınızı kontrol edip tekrar deneyin.",
  "locationTypes.inUseWarning.one": "Bu tipte {count} lokasyon var.",
  "locationTypes.inUseWarning.other": "Bu tipte {count} lokasyon var.",
  "operations.inUseWarning.one": "Bu operasyonda {count} bölge var.",
  "operations.inUseWarning.other": "Bu operasyonda {count} bölge var.",
  "regions.inUseWarning.one": "Bu bölgede {count} lokasyon var.",
  "regions.inUseWarning.other": "Bu bölgede {count} lokasyon var.",
  "countries.inUseWarning.one": "Bu ülkede {count} lokasyon var.",
  "countries.inUseWarning.other": "Bu ülkede {count} lokasyon var.",
  "countries.hasCitiesWarning.one": "Bu ülkede {count} şehir tanımlı.",
  "countries.hasCitiesWarning.other": "Bu ülkede {count} şehir tanımlı.",
  "cities.inUseWarning.one": "Bu şehirde {count} lokasyon var.",
  "cities.inUseWarning.other": "Bu şehirde {count} lokasyon var.",
  "cities.hasDistrictsWarning.one": "Bu şehirde {count} ilçe tanımlı.",
  "cities.hasDistrictsWarning.other": "Bu şehirde {count} ilçe tanımlı.",
  "districts.inUseWarning.one": "Bu ilçede {count} lokasyon var.",
  "districts.inUseWarning.other": "Bu ilçede {count} lokasyon var.",
  "checklistTitles.inUseWarning.one": "Bu başlık {count} kategoriyi grupluyor.",
  "checklistTitles.inUseWarning.other": "Bu başlık {count} kategoriyi grupluyor.",
  "scoreBands.deleteWarning": "Aralık silinirse altında kalan puanlar aralıksız kalır; kalanları gözden geçirin.",
  "audits.discard": "Taslağı sil",
  "audits.discardTitle": "{location} taslağı silinsin mi?",
  "audits.discardWarning": "Girilen cevaplar ve fotoğraflar da silinir. Denetim izinde kaydı kalır.",
  "error.audit.not-yours": "Bu ziyareti başka bir denetmen açmış; yalnız o silebilir.",
  'error.audit.has-actions': 'Bu ziyaretten aksiyon açılmış ({count}), bu yüzden silinemez. Aksiyonlar numaralarıyla takipte ve ziyaret silinirse dayanaksız kalır.',
};
